import uuid from 'uuid-random';
import { log } from 'log';
import { prop } from 'ramda';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslations } from 'js/hooks/i18n';
import { useSmartClosePopups } from 'js/components/common/PopupManager';
import { useUserSelector } from 'js/store/hooks';
import { languageService } from 'js/services/language.service';

import { showGeoComplyPopupAction } from '../../../actions';

export const GEOCOMPLY_OOBEE_HINT_POPUP_ID = uuid();

export const useRequestOobeePacket = ({
    sdk,
    oobeeURL,
    license,
    transactionID,
    useTransparentPopup,
    disableStoreAutoLaunch,
    setShowOverlay,
    userId,
    identifierType,
    onError,
    receivePacket
}) => {
    const dispatch = useDispatch();
    const t = useTranslations();
    const closePopups = useSmartClosePopups();
    const lang = useUserSelector(prop('lang'));
    const twoLetterLang = languageService.getTwoLetterLanguage(lang);

    return useCallback(() => {
        log('gcReq', {
            transactionID,
            license
        });

        sdk.setupAndGeolocate({
            license,
            userId,
            oobeeUrl: oobeeURL,
            session: transactionID,
            reason: 'bet',
            customFields: {
                transactionId: transactionID, // eslint-disable-next-line camelcase
                identifier_type: identifierType,
                language: twoLetterLang
            }, ...disableStoreAutoLaunch ? {
                enablePlayStorePopUp: false,
                autoOpenPlayAppStore: false
            } : {}
        }, (data) => {
            switch (data.type) {
                case 'LOG':
                    log('gcReq', {
                        transactionID,
                        license,
                        message: data.message
                    });
                    break;
                case 'INTERACTION':
                    dispatch(showGeoComplyPopupAction({
                        id: GEOCOMPLY_OOBEE_HINT_POPUP_ID,
                        title: 'playtech.mobile.system.geocomply.popups.error.title',
                        content: t(`playtech.mobile.system.geocomply.popups.hint.${data.reason}`, data.message),
                        isModal: true,
                        buttons: [
                            {
                                onClick: () => {
                                    closePopups(GEOCOMPLY_OOBEE_HINT_POPUP_ID);
                                    data.yes();
                                },
                                text: 'playtech.mobile.system.geocomply.popups.error.open',
                                color: 'success'
                            }, {
                                onClick: () => {
                                    setShowOverlay(false);
                                    closePopups(GEOCOMPLY_OOBEE_HINT_POPUP_ID);
                                    data.no();
                                },
                                text: 'playtech.mobile.system.geocomply.popups.error.ignore',
                                color: 'negative'
                            }
                        ],
                        useTransparentPopup
                    }));
                    break;
                default:
                // noop
            }
        }, (err, data) => {
            if (err) {
                onError(err.error_code, err.error_message);
            } else {
                receivePacket(data, 'geocomply', transactionID);
            }
        });
    }, [
        sdk,
        license,
        t,
        transactionID,
        closePopups,
        userId,
        dispatch,
        twoLetterLang,
        identifierType,
        setShowOverlay,
        useTransparentPopup,
        disableStoreAutoLaunch,
        oobeeURL,
        onError,
        receivePacket
    ]);
};
